export class CompanyInternLocationsDataModel implements ICompanyInternLocationsDataModel {
  location?: string | undefined;
  count?: number | undefined;
  studentIds?: string[] | undefined;

  constructor(data?: ICompanyInternLocationsDataModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.location = Data["location"];
      this.count = Data["count"];
      if (Array.isArray(Data["studentIds"])) {
        this.studentIds = [] as any;
        for (let item of Data["studentIds"])
          this.studentIds!.push(item);
      }
    }
  }

  static fromJS(data: any): CompanyInternLocationsDataModel {
    data = typeof data === 'object' ? data : {};
    let result = new CompanyInternLocationsDataModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["location"] = this.location;
    data["count"] = this.count;
    if (Array.isArray(this.studentIds)) {
      data["studentIds"] = [];
      for (let item of this.studentIds)
        data["studentIds"].push(item);
    }
    return data;
  }
}

export interface ICompanyInternLocationsDataModel {
  location?: string | undefined;
  count?: number | undefined;
  studentIds?: string[] | undefined;
}